import { CalculateTotalBeneficiariesProps } from './types';

export function calculateTotalBeneficiaries(
  summaryValues: CalculateTotalBeneficiariesProps,
): number {
  return Object.values(summaryValues).reduce((acc, curr) => acc + curr, 0);
}
